(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Nykyinen haku',
    noCollectionFound: 'Tuoteryhmiä ei löytynyt',
    allProducts: 'Näytä kaikki tuotteet',
    matching: 'hakusanalla',
    sortBy: 'Lajittelu',
    relevance: 'Osuvuus',
    outOf: '/',
    resultsFound: 'löytynyttä hakutulosta',
    oneResultFound: '1 löytynyt hakutulos',
    noResultFound: 'Ei löydettyjä hakutuloksia',
    addToCart: 'Lisää ostoskoriin',
    searchForProduct: 'Hae tuotteita',
    selectedFilter: 'Valitut rajaukset',
    clearAll: 'Poista kaikki',
    noPageFound: 'Sivua ei löytynyt',
    outOfStock: 'Loppuunmyyty',
    showFilters: 'Näytä rajaukset',
    hideFilters: 'Piilota rajaukset',
    collections: 'Tuoteryhmät',
    articles: 'Artikkelit',
    pages: 'Sisällöt',
    from: "alk. {{ price }}",
    showMore: 'Näytä enemmän',
    showLess: 'Näytä vähemmän'
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Ei tuloksia hakusanalle ' + render(text);
    },
    in: function() {
      return '';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Yritä uudelleen ' +
        render(html_tags[0]) +
        ' vähentämällä rajauksia ' +
        render(html_tags[1]) +
        ' tai ' +
        render(html_tags[2]) +
        ' vaihtamalla käyttämääsi hakusanaa ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits)
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
